module.exports = __webpack_public_path__ + "static/pencil-0671afc817466c247800ac115cdfa791.png";